import Validatable from "../../../common/mixins/validatable";
import CertificateBuilderModel from "../../../common/models/tracked/certificateBuilderModel";
import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import Guid from "~/helpers/guid";
import Certificate from "./certificate";
import CertificateFoundationLayerContainer from "./certificateFoundationLayerContainer";
import CertificateElement from "./certificateElement";
import BaseCertificateElement from "./baseCertificateElement";

export default class CertificateFoundationLayer extends CertificateFoundationLayerContainer(Validatable(CertificateBuilderModel)) {

  static repo: IRepo<CertificateFoundationLayer> = new Repo<CertificateFoundationLayer>('certificateFoundationLayers', CertificateFoundationLayer);

  client_id: string;
  custom_name: string = "";
  sort_order: number = 0;
  pages: string[] = [];
  source_document: string = "";
  source_page: string = "";
  opacity: number = 1.0;

  get rootName(): string {
    return 'certificate_foundation_layers';
  }

  definePropertiesFrom(parent: Certificate | CertificateFoundationLayer | CertificateElement | BaseCertificateElement, json: object) {
    this.defineProperty('client_id', json["client_id"] || Guid.create());
    this.defineProperty("custom_name", json['name'] || this.custom_name);
    this.defineProperty('sort_order', json['sort_order'] || this.sort_order);
    this.defineProperty('pages', json['pages'] || this.pages);
    this.defineProperty('source_document', json['source_document'] || this.source_document);
    this.defineProperty('source_page', json['source_page'] || this.source_page);
    this.defineProperty('opacity', json['opacity'] || this.opacity);
  }

  getDisplayName(): string {
    return "Foundation Layers"
  }

  get certificate(): Certificate {
    return this.parent;
  }

  get layerNumber(): number {
    return this.certificate.foundationLayers.indexOf(this) + 1;
  }

}